import React, { useState } from 'react';
import { FiDroplet } from 'react-icons/fi';
import tnsLogo from '../../../assets/images/tnslogo.png';

const OPTEnterPin = ({ onCancel, onSubmit, amount }) => {
  const [pin, setPin] = useState('');
  
  const addDigit = (digit) => {
    if (pin.length < 4) {
      setPin(prev => prev + digit);
    }
  };

  const formatPinDisplay = () => {
    return '•'.repeat(pin.length) + '_'.repeat(4 - pin.length);
  };

  return (
    <div className="bg-white text-gray-800 h-full flex flex-col overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between px-3 py-2 border-b border-gray-100 flex-shrink-0">
        <div className="flex items-center space-x-1.5">
          <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
            <FiDroplet className="w-3 h-3 text-white" />
          </div>
          <span className="font-bold text-gray-800 text-xs">Fuel Co</span>
        </div>
        <div className="flex items-center space-x-1">
          <span className="text-[10px] text-gray-400">Powered by</span>
          <img src={tnsLogo} alt="TNS" className="h-4" />
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col px-3 py-2">
        {/* Amount */}
        <div className="bg-blue-600 text-white rounded-lg px-3 py-1.5 mb-2">
          <div className="text-[10px]">Total</div>
          <div className="text-sm font-bold">${amount || '0.00'}</div>
        </div>

        {/* PIN display */}
        <div className="mb-1">
          <div className="text-xs font-semibold">Enter PIN</div>
          <div className="text-base font-mono tracking-widest text-gray-700">{formatPinDisplay()}</div>
          <div className="h-0.5 bg-blue-600 rounded-full mt-0.5 mb-1"></div>
          <div className="text-[9px] text-gray-500">If no PIN, press OK</div>
        </div>

        {/* Keypad */}
        <div className="grid grid-cols-4 gap-1 flex-1 items-center">
          {[1,2,3].map(n => (
            <button key={n} onClick={() => addDigit(String(n))}
              className="bg-white border border-gray-200 rounded-lg h-7 text-sm font-medium hover:bg-gray-50">{n}</button>
          ))}
          <button onClick={() => setPin(prev => prev.slice(0, -1))}
            className="bg-white border border-gray-200 rounded-lg h-7 text-xs font-medium hover:bg-gray-50">⌫</button>

          {[4,5,6].map(n => (
            <button key={n} onClick={() => addDigit(String(n))}
              className="bg-white border border-gray-200 rounded-lg h-7 text-sm font-medium hover:bg-gray-50">{n}</button>
          ))}
          <button onClick={() => setPin('')}
            className="bg-white border border-gray-200 rounded-lg h-7 text-[10px] font-medium hover:bg-gray-50">Clear</button>

          {[7,8,9].map(n => (
            <button key={n} onClick={() => addDigit(String(n))}
              className="bg-white border border-gray-200 rounded-lg h-7 text-sm font-medium hover:bg-gray-50">{n}</button>
          ))}
          <button onClick={() => onSubmit(pin.length === 4 ? pin : 'NO_PIN')}
            className="bg-blue-600 text-white rounded-lg h-[60px] text-xs font-bold hover:bg-blue-700 row-span-2">OK</button>

          <div></div>
          <button onClick={() => addDigit('0')}
            className="bg-white border border-gray-200 rounded-lg h-7 text-sm font-medium hover:bg-gray-50">0</button>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default OPTEnterPin;
